<template><div class="containerTable">
  <commonRouteInfoList :parent-data="parentData" />
</div>
</template>
<script>
import commonRouteInfoList from "@/views/basicInfo/shipment/shipmentForm/components/commonRouteInfo/commonRouteInfoList.vue";
export default {
  name: "RegularRoute",
  components: {
    commonRouteInfoList
  },
  data() {
    return {
      areaOptions: this.$store.state.components.areaOptions,
      parentData: {
        areaOptions: this.$store.state.components.areaOptions,
      }
    };
  }
};
</script>
